import type { ApiQuery } from '../../../shared/api/contracts'
import type { AuditLogItem } from '../../../shared/api/models'
import { apiGet } from './transport'

export async function fetchAuditLog(params: ApiQuery<'GET /admin/audit-log'>, signal?: AbortSignal): Promise<{ ok: true; items: AuditLogItem[]; total: number; limit: number; offset: number }> {
  const u = new URLSearchParams()
  if (params.limit != null) u.set('limit', String(params.limit))
  if (params.offset != null) u.set('offset', String(params.offset))
  if (params.resourceType) u.set('resourceType', String(params.resourceType))
  if (params.action) u.set('action', String(params.action))
  if (params.actorTelegramUserId != null) u.set('actorTelegramUserId', String(params.actorTelegramUserId))
  if (params.dateFrom) u.set('dateFrom', params.dateFrom)
  if (params.dateTo) u.set('dateTo', params.dateTo)
  const qs = u.toString()
  return apiGet<'GET /admin/audit-log'>(
    `/admin/audit-log${qs ? `?${qs}` as const : ''}`, signal
  )
}
